module.exports = __webpack_public_path__ + "static/media/visa.98edc46d.png";